import { Key } from "../actions/loadName"

export function save(store) {
  store.subscribe(() => {
    const state = store.getState()
    if (state.name) {
      window.localStorage.setItem(Key, state.name)
    }
    else {
      window.localStorage.removeItem(Key)
    }
  })
}

export default save
